import React, { Component, Fragment } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import AccountSummary from "./AccountSummary/AccountSummary";
import BalanceSummary from "./BalanceSummary/BalanceSummary";
import Panel from "./Panel/Panel";
import { Link } from "react-router";
import styles from "./Account.module.less";
import WithAccount, { AccountLoadStatus } from "../WithAccounts/WithAccount";
import classnames from "classnames";
import callbackPromise from "../CallbackRequest/async";
import { messages as callbackMessages } from "../Callback/Callback";
import * as Icons from "./Icons";
import { getRoutePaymentStatus } from "assets/scripts/domain/payment/paymentUtils";
import moment from "moment";
import isSettlementEligible from "assets/scripts/domain/accts/isSettlementEligible";
import track from "react-tracking";
const messages = defineMessages({
    manageAccountHeading: {
        id: "account.manageAccount.heading",
        defaultMessage: "Manage Account"
    },
    callback: {
        id: "account.manageAccount.callback",
        defaultMessage: "Request a Callback"
    },
    callbackCancel: {
        id: "account.manageAccount.callback.cancel",
        defaultMessage: "Cancel Scheduled Callback"
    },
    schedulePayment: {
        id: "account.manageAccount.schedulePayment",
        defaultMessage: "Schedule a Payment"
    },
    makePayment: {
        id: "account.manageAccount.makePayment",
        defaultMessage: "Make a Payment"
    },
    probateCase: {
        id: "account.manageAccount.probateCase",
        defaultMessage: "Submit Probate Case Information"
    },
    settlementOptions: {
        id: "account.manageAccount.settlementOptions",
        defaultMessage: "Settlement Options"
    }
});
const ActionLink = (props) => {
    const inner = (<Fragment>
			{props.icon}
			<span>
				<FormattedMessage {...props.label}/>
			</span>
		</Fragment>);
    if (props.disabled) {
        return (<li>
				<button type="button" className={classnames("link", styles.disabled)} disabled>
					{inner}
				</button>
			</li>);
    }
    return (<li>
			<Link to={props.to} className="link">
				{inner}
			</Link>
		</li>);
};
class Account extends Component {
    constructor() {
        super(...arguments);
        this._isMounted = true;
        this.state = {
            CallbackSummary: null
        };
    }
    async componentDidMount() {
        this._isMounted = true;
        const { CallbackSummary } = await callbackPromise;
        if (this._isMounted) {
            this.setState({ CallbackSummary });
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        const { props } = this;
        const { CallbackSummary } = this.state;
        const id = parseInt(props.params.id, 10);
        return (<WithAccount acctId={id}>
				{({ loading, error, acct }) => {
            loading = loading || CallbackSummary == null;
            return (<div className="wrapper">
							<h1 className="u-isVisuallyHidden js-pageHeader">
								<FormattedMessage id="account.header" defaultMessage="Account Details"/>
							</h1>

							<AccountLoadStatus loading={loading} error={error}/>

							{CallbackSummary != null && !loading && acct != null && (this._renderAcct(acct, CallbackSummary))}
						</div>);
        }}
			</WithAccount>);
    }
    _renderAcct(group, CallbackSummary) {
        const { paymentAllowed } = getRoutePaymentStatus(group, moment());
        const settlementEligible = paymentAllowed && isSettlementEligible(group);
        const actions = [
            (group.primary.allowCallback || group.callbackAccount.callback != null) && (<ActionLink key={0} to={`/secured/callback/${group.callbackAccount.id}`} label={group.callbackAccount.callback == null ? messages.callback : messages.callbackCancel} icon={Icons.CALLBACK}/>),
            (<ActionLink key={1} to={`/secured/payNow/${group.primary.id}`} label={group.primary.allowScheduledPayment ? messages.schedulePayment : messages.makePayment} disabled={!paymentAllowed} icon={Icons.SCHEDULE}/>),
            process.env.FEATURE_PROBATE_CASE_SUBMISSION && (<ActionLink key={2} to={`/secured/probateCase/${group.primary.id}`} label={messages.probateCase} icon={Icons.COURT}/>),
            settlementEligible && (<ActionLink key={3} to={`/secured/settlement/${group.primary.id}`} label={messages.settlementOptions} icon={Icons.MONEY}/>)
        ].filter(Boolean);
        return (<div>
				<AccountSummary routeGroup={group}/>
				<Panel heading={messages.manageAccountHeading}>
					<ul className={styles.icons} data-length={actions.length}>
						{actions}
					</ul>
				</Panel>

				<BalanceSummary acct={group}/>

				{group.callbackAccount.callback != null && (<Panel heading={callbackMessages.headerUpcoming} className={styles.callbackPanel}>
						<CallbackSummary callback={group.callbackAccount.callback}/>
					</Panel>)}
			</div>);
    }
}
export default track({ page: "Account" }, { dispatchOnMount: true })(Account);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Account/Account.tsx